import React from "react";
import styles from "./error-message.module.css";

const ErrorMessage: React.FC<{ errorMsg?: string; }> = ({ errorMsg }) => {
  if (!errorMsg) return null;
  return (
    <div className={styles.errorMsgWrap}>
      {errorMsg}
    </div>
  );
};
export default ErrorMessage;
